export default 'M.5 8c0-.83.67-1.5 1.5-1.5h12a1.5 1.5 0 0 1 0 3H2A1.5 1.5 0 0 1 .5 8';